export default __webpack_public_path__ + "static/media/pengiriman-paket-edit.a9aecd4f.jpg";